module.exports = __webpack_public_path__ + "fonts/GothamCondensed-Medium.63ccafb.otf";